import { render, staticRenderFns } from "./resource-folder.vue?vue&type=template&id=de463510&scoped=true&"
import script from "./resource-folder.vue?vue&type=script&lang=ts&"
export * from "./resource-folder.vue?vue&type=script&lang=ts&"
import style0 from "./resource-folder.vue?vue&type=style&index=0&id=de463510&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de463510",
  null
  
)

export default component.exports